



























































































import { Component, Vue } from "vue-property-decorator";
import { stateTypeList, fieldList, onChange } from "../config";
import { timeOption } from "@/views/OperationLog/config";
@Component({
  components: {},
})
export default class Home extends Vue {
  public info: any = {
    game_id: "",
    user_id: "",
    user_account: "",
    seller_user_id: "",
    commodity_id: "",
    status: [],
    s_time: "",
    e_time: "",
    field_str: "counter_offer_time",
  };
  public stateTypeList = stateTypeList;
  public fieldList = fieldList;
  public dateTime: any = ["", ""];
  public options = timeOption;
  public onChange = onChange;
  public gameChange(val) {
    if (!val) this.info.game_id = "";
  }
  public stateChange(val) {
    if (!val) this.info.status = "";
  }
  public changeTime(date) {
    this.info.s_time = date[0];
    this.info.e_time = date[1];
  }
  public toSearch() {
    const info = JSON.parse(JSON.stringify(this.info));
    this.$emit("toSearch", info);
  }
  public toExportExcel() {
    this.$emit("toExportExcel");
  }
}
